function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("polygon", {
  className: "white",
  points: "128 32 32 104 128 176 224 104 128 32"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M232,128v84a12,12,0,0,1-12,12H36a12,12,0,0,1-12-12V120c0-3.46-2.34-13.8,0-16l104,72,104-72C234.34,106.2,232,124.54,232,128Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M232,104V212.39A11.81,11.81,0,0,1,220,224H36a11.81,11.81,0,0,1-12-11.61V104"
}), React.createElement("polyline", {
  className: "primary",
  points: "232 104 128 176 24 104"
}), React.createElement("line", {
  className: "primary",
  x1: 28.89,
  y1: 211.11,
  x2: 88,
  y2: 152
}), React.createElement("line", {
  className: "primary",
  x1: 228.29,
  y1: 212.29,
  x2: 168,
  y2: 152
}), React.createElement("polyline", {
  className: "primary",
  points: "24 103.92 128 32 232 104"
})));
var SvgEmailOpened = function SvgEmailOpened(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmailOpened, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmailOpened.ddfbe54c.svg";
export { ForwardRef as ReactComponent };